import { RootState } from 'store/store';

/**
 * Returns true if the journey has any Email nodes.
 * Used to conditionally mount EmailSidePanel and avoid unnecessary template fetches.
 */
export function selectHasEmailNodes(teState: RootState['te']): boolean {
  return (teState.email.allRefId?.length ?? 0) > 0;
}
